<template>
  <ReadRow :columns="3">
    <ReadField label="Document Date" :val="sysDate.shortDateString(item?.documentDate)" />
    <ReadField label="Received Date" :val="sysDate.shortDateString(item?.receivedDate)" />
    <ReadField label="Due Date" :val="sysDate.shortDateString(item?.dueDate)" />
  </ReadRow>
  <ReadField
    label="Letter Status"
    v-if="isLetter(item?.typeMurn)"
    :val="item?.letterStatusMurn"
    :lookup-format="LookupFormat.description"
  />
  <ReadField
    label="Status Effective Date"
    v-if="isLetter(item?.typeMurn)"
    :val="sysDate.shortDateString(item?.letterStatusDate)"
  />
</template>

<script lang="ts">
export default defineComponent({
  name: "DocumentListPageExtension",
});
</script>

<script setup lang="ts" generic="T extends Doc">
import { LE } from "@/constants/enums";
import type { Doc } from "@modernary/mui/components/document";
import { LookupFormat, ReadField, ReadRow } from "@modernary/mui/components/read";
import { sysDate } from "@modernary/mui/utils/filters";
import { defineComponent } from "vue";

function isLetter(murn?: string) {
  return (
    murn === LE.DocumentType.NFALetter ||
    murn === LE.DocumentType.NFARestrictionsLetter ||
    murn === LE.DocumentType.FWLetter ||
    murn === LE.DocumentType.CRNLetter
  );
}
defineProps<{ item?: T }>();
</script>
